import React from "react";
import { Typography } from "@mui/material";
import currency from "currency.js";
import { getItemSurchargeTotal } from "../../util";

export default function TotalSurchargeLabel(props) {
  const { item } = props;

  if (item.variant && item.price) {
    const surcharge = getItemSurchargeTotal(item.variant, item.price);
    if (surcharge > 0) {
      return (
        <Typography variant="caption" color="textSecondary">
          +{currency(surcharge).format()} surcharge
        </Typography>
      );
    }
  }

  return <></>;
}
